export default __webpack_public_path__ + "static/media/mathema.e7af7b6f.svg";